import { InjectProperty } from '@jack-henry/frontend-utils/di';
import { Feature, FeatureFlagService } from '@treasury/domain/services/feature-flags';
import { TmBaseComponent } from '@treasury/presentation';
import { cardsIcon } from '@treasury/presentation/assets/icons';
import '@treasury/presentation/components/tm-button';
import { css, html, nothing } from 'lit';
import { customElement, state } from 'lit/decorators.js';

export const tagName = 'configure-widgets-button';

@customElement(tagName)
export class ConfigureWidgetsButton extends TmBaseComponent {
    @InjectProperty({
        async: true,
        token: FeatureFlagService,
    })
    declare private featureFlagService: Promise<FeatureFlagService>;

    @state()
    private hasConfigureDashboard = false;

    protected async firstUpdated() {
        this.hasConfigureDashboard = await (
            await this.featureFlagService
        ).isEnabled(Feature.PwaConfigureDashboard);
    }

    protected render() {
        return this.hasConfigureDashboard
            ? html`<div class="w-full flex flex-col items-center">
                  <button
                      class="w-full py-4 items-center flex justify-center rounded-lg bg-[#444444] text-[#E6E6E6]"
                      @click=${() =>
                          this.dispatchEvent(
                              new CustomEvent('configure-dashboard', {
                                  bubbles: true,
                                  composed: true,
                              })
                          )}
                  >
                      <div class="flex items-center">
                          <tm-icon .icon=${cardsIcon} color="#E6E6E6" class="mr-2"></tm-icon>
                          <span>Organize Dashboard</span>
                      </div>
                  </button>
              </div>`
            : nothing;
    }

    public static get styles() {
        return [
            css`
                :host {
                    display: block;
                }
            `,
        ];
    }
}

declare global {
    interface HTMLElementTagNameMap {
        [tagName]: ConfigureWidgetsButton;
    }
}
